import React from 'react'
import { Loading } from '@myxplor/ui'
import LocalAsyncStore from '../../../../../local-async-store'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import { formDefaultValues } from './helpers'
import UpdateMyChildFormFields from './form'

export const isMyChildVacanciesFeatureEnabled = () => process.env.REACT_APP_ENABLE_UPDATE_MYCHILD_AND_VACANCIES === 'true'

const available = record => isMyChildVacanciesFeatureEnabled() && hasAvailableAction(record, 'update_mychild')

const apiEndPoint = ({ gov_id }) => `/api/service-registrations/${gov_id}/my-child`

const submitEndPoint = record => process.env.REACT_APP_API_HOST + apiEndPoint(record)

const formValue = 'edit_mychild'

const editMyChildForm = record => ({ mychild, handleSuccess }) => {
  if (mychild.loading || !mychild.data) {
    return <Loading>Loading MyChild information</Loading>
  }

  return (
    <DefaultForm
      url={submitEndPoint(record)}
      value={formValue}
      formComponent={UpdateMyChildFormFields}
      formOptions={{
        defaultValues: formDefaultValues(mychild.data),
      }}
      label="Update MyChild"
      loadingTitle="Updating MyChild..."
      handleSuccess={() =>
        handleSuccess(
          { [formValue]: 'Your MyChild Information & Vacancies has been updated' },
          formValue
        )
      }
    />
  )
}

const editMyChildFormWrapper = record =>
  LocalAsyncStore('mychild', editMyChildForm(record), () => apiEndPoint(record))

const editMyChild = ({ record }) =>
  available(record)
    ? {
      label: 'Update MyChild Information & Vacancies',
      value: formValue,
      actionForm: editMyChildFormWrapper(record),
      onCompletePreserveAction: true,
    }
    : null

export default editMyChild



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/actions/update-myChild/index.js